import "./AccessTab.css";

import {
  AssignResponsibleOwnerModal,
  InformationBox,
  ProjectAccessTable,
  ProjectInvitesTable,
} from "../../../../../../widget";
import { useAccessTab } from "./useAccessTab";

interface AccessTabProps {
  type?: "seed" | "default" | undefined;
}

export const AccessTab = ({ type }: AccessTabProps): JSX.Element => {
  const {
    accessRows,
    accessIsLoading,
    hasAccessError,
    onResponsibleOwnerChange,
    onEditAccess,
    onSaveAccessEdit,
    onCancelAccessEdit,
    showAssignResponsibleOwnerModal,
    newResponsibleOwnerName,
    currentResponsibleOwnerName,
    onConfirmAssignResponsibleOwner,
    onCancelAssignResponsibleOwner,
    isEditingAccess,
    isSavingAccess,
    canManageAccess,
    showInvitesTable,
    onNewInvitation,
    onViewInvite,
    invitesIsLoading,
    isPreAccess,
    projectUuid,
    onChange,
  } = useAccessTab();

  if (isPreAccess) {
    return (
      <div className="ProjectTabSection ProjectAccessTab">
        <InformationBox variant="info" corners={type === "seed" ? "rounded" : "default"}>
          Your organisation doesn&apos;t have access to this project.
        </InformationBox>
      </div>
    );
  }

  return (
    <>
      <div className="ProjectTabSection ProjectAccessTab ProjectAccessTab_access">
        <ProjectAccessTable
          rows={accessRows}
          onResponsibleOwnerChange={onResponsibleOwnerChange}
          canEdit={canManageAccess}
          isEditing={isEditingAccess}
          onEditClick={onEditAccess}
          onSave={onSaveAccessEdit}
          onCancel={onCancelAccessEdit}
          isSaving={isSavingAccess}
          isLoading={accessIsLoading}
          hasError={hasAccessError}
          variant={type}
        />
      </div>
      {showInvitesTable && (
        <div className="ProjectTabSection ProjectAccessTab ProjectAccessTab_invites">
          {/* Keyed so a :projectUuid change while the tab stays mounted remounts the grid and reloads
              it - ProjectInvitesTable exposes no refresh prop of its own. */}
          <ProjectInvitesTable
            key={projectUuid}
            rows={[]}
            canCreateInvitation={canManageAccess}
            onNewInvitation={onNewInvitation}
            onView={onViewInvite}
            isLoading={invitesIsLoading}
            onChange={onChange}
            variant={type}
          />
        </div>
      )}
      <AssignResponsibleOwnerModal
        show={showAssignResponsibleOwnerModal}
        newOwnerName={newResponsibleOwnerName}
        currentOwnerName={currentResponsibleOwnerName}
        onConfirm={onConfirmAssignResponsibleOwner}
        onCancel={onCancelAssignResponsibleOwner}
        isLoading={isSavingAccess}
      />
    </>
  );
};
